export default {
  'TIMELINEBANNER' (state) {
    return state.timelinebanner
  },
  'TIMELINEBANNERS' (state) {
    return state.timelinebanners
  }
}
